/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
/**
 * @hidden
 */
var AnimationKeyFrameEffectTiming = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(AnimationKeyFrameEffectTiming, _super);
    function AnimationKeyFrameEffectTiming() {
        var _this = _super.call(this) || this;
        _this.f = 0;
        _this.c = 0;
        _this.g = 0;
        _this.b = 0;
        _this.h = 0;
        _this.a = 0;
        _this.j = 0;
        _this.i = 0;
        _this.onFinished = null;
        _this.onCanceled = null;
        _this.f = 0;
        _this.c = 0;
        _this.b = 3;
        _this.h = 0;
        _this.a = 0;
        _this.j = 0;
        _this.i = 1;
        return _this;
    }
    AnimationKeyFrameEffectTiming.$t = markType(AnimationKeyFrameEffectTiming, 'AnimationKeyFrameEffectTiming');
    return AnimationKeyFrameEffectTiming;
}(Base));
export { AnimationKeyFrameEffectTiming };
//# sourceMappingURL=AnimationKeyFrameEffectTiming.js.map
